import { NSARouterMakerResult } from "namirasoft-account-react";
import { KnowledgebaseItemInputRow, KnowledgebaseItemRow, KnowledgebaseItemType } from "namirasoft-inference";
import { NSBox, NSBoxString, NSBoxEnum, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface KnowledgebaseItemEditPageProps extends NSARouterMakerResult, InferenceRouterProps
{
    isEdit: boolean;
}

export default class KnowledgebaseItemEditPage extends Component<KnowledgebaseItemEditPageProps>
{
    NSBoxString_KnowledgebaseID = createRef<NSBoxString>();
    NSBoxString_Name = createRef<NSBoxString>();
    NSBoxEnum_Type = createRef<NSBoxEnum<KnowledgebaseItemType>>();
    NSBoxString_Value = createRef<NSBoxString>();
    NSBoxString_Description = createRef<NSBoxString>();

    override render()
    {
        return (
            <InferenceLayout<KnowledgebaseItemRow, KnowledgebaseItemInputRow>
                {...this.props}
                action={{ description: this.props.isEdit ? InferenceInfo.knowledgebase_item.edit : InferenceInfo.knowledgebase_item.create }}
                pages={{
                    entity: InferenceEntities.knowledgebase_item(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): KnowledgebaseItemInputRow =>
                                    {
                                        let knowledgebase_id = this.NSBoxString_KnowledgebaseID.current?.getValue() ?? "";
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let type = (this.NSBoxEnum_Type.current?.getValueOne() as KnowledgebaseItemType | null | undefined) ?? Object.values(KnowledgebaseItemType)[0] as KnowledgebaseItemType;
                                        let value = this.NSBoxString_Value.current?.getValue() ?? "";
                                        let description = this.NSBoxString_Description.current?.getValue() ?? null;
                                        return {
                                            workspace_id: null,
                                            knowledgebase_id,
                                            name,
                                            type,
                                            value,
                                            description,
                                            knowledgebase_item_category: [],
                                            knowledgebase_item_field: [],
                                            knowledgebase_item_tag: [],
                                        };
                                    },
                                    setRow: (row: KnowledgebaseItemRow) =>
                                    {
                                        this.NSBoxString_KnowledgebaseID.current?.setValue(row.knowledgebase_id);
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSBoxEnum_Type.current?.setValue(row.type);
                                        this.NSBoxString_Value.current?.setValue(row.value);
                                        this.NSBoxString_Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString
                        ref={this.NSBoxString_KnowledgebaseID}
                        required
                        title="Knowledgebase ID"
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/knowledgebase/#field-items" }}
                    />
                    <NSBoxString
                        ref={this.NSBoxString_Name}
                        required
                        title="Name"
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/knowledgebase/#field-item-name" }}
                    />
                    <NSBoxEnum<KnowledgebaseItemType>
                        ref={this.NSBoxEnum_Type}
                        title="Type"
                        required
                        multiple={false}
                        getEnumObject={() => KnowledgebaseItemType}
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/knowledgebase/#field-item-type" }}
                    />
                    <NSBoxString
                        ref={this.NSBoxString_Value}
                        required
                        title="Value"
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/knowledgebase/#field-item-value" }}
                    />
                    <NSBoxString
                        ref={this.NSBoxString_Description}
                        required={false}
                        title="Description"
                        style={{ width: NSBox.width.double }}
                        info={{ link: "https://namirasoft.com/inference/console-guide/knowledgebase/#field-item-description" }}
                    />
                </NSColumn>
            </InferenceLayout>
        );
    }
}